import { render } from "./lista_SpareParts.vue?vue&type=template&id=8b4b7120"
import script from "./lista_SpareParts.vue?vue&type=script&lang=js"
export * from "./lista_SpareParts.vue?vue&type=script&lang=js"

import "./lista_SpareParts.vue?vue&type=style&index=0&id=8b4b7120&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__